
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ThresholdSettingProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const ThresholdSetting = ({ 
  value, 
  onChange, 
  disabled = false 
}: ThresholdSettingProps) => {
  return (
    <div className="space-y-4">
      <Label className="text-sm text-muted-foreground">Alert me when products have less than:</Label>
      <div className="flex items-center space-x-2">
        <Input
          type="number"
          min="1"
          max="90"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value) || 7)}
          className="w-20"
          disabled={disabled}
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <span>days of supply remaining</span>
      </div>
    </div>
  );
};

export default ThresholdSetting;
